let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bqWWL")).then(() => parcelRequire('5Yzmr'));